import { useCallback, useState } from "react";

export default function useNow() {
  const [date, setDate] = useState(() => new Date());
  const setNow = useCallback(() => setDate(new Date()), []);
  return [date, setNow] as const;
}
